import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { exchangeCode, takeCallbackContext } from '../utils/connect';

// Connect sends the browser back here with ?code&state. The code is exchanged by the backend
// (it holds the client secret); this page only checks the state and hands the tokens over.
const OAuthCallback = () => {
  const { completeLogin } = useAuth();
  const navigate = useNavigate();
  const called = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (called.current) return; // StrictMode replays effects; the code is single-use
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const connectError = params.get('error');
    const { state: expected, returnTo } = takeCallbackContext();

    if (connectError) {
      setError(`Connect a refusé la connexion (${connectError}).`);
      return;
    }
    if (!code || !state || state !== expected) {
      setError('Retour de connexion invalide. Recommencez depuis la page de connexion.');
      return;
    }

    exchangeCode({ code, state })
      .then(async (tokens) => {
        const ok = await completeLogin(tokens);
        navigate(ok ? returnTo : '/', { replace: true });
      })
      .catch(() => setError('La connexion a échoué. Réessayez.'));
  }, [completeLogin, navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
      {error ? (
        <div className="max-w-md p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg text-center">
          <p className="mb-4 text-red-700 dark:text-red-200">{error}</p>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            type="button"
            onClick={() => window.location.assign('/')}
          >
            Retour
          </button>
        </div>
      ) : (
        <div className="text-xl font-medium text-gray-700 dark:text-gray-200">Connexion en cours…</div>
      )}
    </div>
  );
};

export default OAuthCallback;
